import { type ComponentProps } from "react";

export const Hail = (props: ComponentProps<"svg">) => (
  <svg
    width="100%"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 22.9107C4.44938 21.1323 2 17.3628 2 13C2 6.92487 6.74949 2 12.6083 2C17.469 2 21.5661 5.38976 22.821 10.0139C22.9626 10.0047 23.1054 10 23.2493 10C26.9776 10 30 13.134 30 17C30 20.6028 27.375 23.57 24 23.9572V21.937C26.2205 21.5615 28 19.5486 28 17C28 14.1696 25.8053 12 23.2493 12C22.5272 12 21.8339 12.1732 21.2108 12.4855C21.1791 11.9037 21.0937 11.3367 20.9599 10.7899L20.9569 10.7911C20.0091 6.85004 16.5839 4 12.6083 4C7.92179 4 4 7.96046 4 13C4 16.2291 5.61019 19.0152 8 20.6003V22.9107ZM12.4997 23.0021C12.7419 23.0021 12.9999 22.7921 12.9998 22.456C12.9997 22.272 12.9366 21.9263 12.7412 21.4168C12.6633 21.2136 12.5723 21.0045 12.4721 20.7938C12.173 21.4437 11.9992 22.0277 11.9994 22.456C11.9995 22.7921 12.2576 23.0021 12.4997 23.0021ZM11.29 18.7572C11.9005 17.7302 12.4979 17 12.4979 17C12.4979 17 13.0675 17.7554 13.6632 18.7778C14.3157 19.8977 14.9995 21.3379 14.9998 22.456C15.0002 23.8622 13.8812 25.0021 12.5004 25.0021C11.1195 25.0021 9.99979 23.8622 9.99935 22.456C9.99898 21.229 10.6517 19.8309 11.29 18.7572ZM20.0021 22.456C20.0022 22.7921 19.7442 23.0021 19.5021 23.0021C19.2599 23.0021 19.0018 22.7921 19.0017 22.456C19.0015 22.0277 19.1753 21.4437 19.4744 20.7938C19.5746 21.0045 19.6656 21.2136 19.7435 21.4168C19.9389 21.9263 20.0021 22.272 20.0021 22.456ZM19.5002 17C19.5002 17 18.9029 17.7302 18.2923 18.7572C17.654 19.8309 17.0013 21.229 17.0017 22.456C17.0021 23.8622 18.1218 25.0021 19.5027 25.0021C20.8835 25.0021 22.0025 23.8622 22.0021 22.456C22.0018 21.3379 21.318 19.8977 20.6655 18.7778C20.0699 17.7554 19.5002 17 19.5002 17Z"
      fill="url(#paint0_linear_3029_20979)"
    />
    <path
      d="M16 26L17.732 27V29L16 30L14.2679 29V27L16 26Z"
      fill="url(#paint1_linear_3029_20979)"
    />
    <path
      d="M22 26L23.732 27V29L22 30L20.2679 29V27L22 26Z"
      fill="url(#paint2_linear_3029_20979)"
    />
    <path
      d="M10 26L11.732 27V29L10 30L8.26794 29V27L10 26Z"
      fill="url(#paint3_linear_3029_20979)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3029_20979"
        x1="16"
        y1="2"
        x2="16"
        y2="25.0021"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#95B6F6" />
        <stop offset="1" stopColor="#5193DE" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3029_20979"
        x1="16"
        y1="26"
        x2="16"
        y2="30"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#CED3EA" />
        <stop offset="1" stopColor="#7E83A9" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_3029_20979"
        x1="22"
        y1="26"
        x2="22"
        y2="30"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#CED3EA" />
        <stop offset="1" stopColor="#7E83A9" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_3029_20979"
        x1="10"
        y1="26"
        x2="10"
        y2="30"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#CED3EA" />
        <stop offset="1" stopColor="#7E83A9" />
      </linearGradient>
    </defs>
  </svg>
);
